import { render } from "./Menu.vue?vue&type=template&id=3ec9f2f8&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=3ec9f2f8&scoped=true&lang=css"

import exportComponent from "/var/www/html/smartbooking/smartbooking-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ec9f2f8"]])

export default __exports__